import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getNestedProperty } from "../../helpers/getNestedProperty";
import { StatusInputWrapper } from "../StatusInputWrapper";
import { streetShortForms } from "../../const/data";
import styles from './Address.module.scss'
import { useRef } from "react";

// address autofill is only used for Home Address input fields and not for mailing address fields
const AddressAutofill = ({
  t,
  label,
  reduxAppProperty,
  changeObjectPropertyAction,
  validateStreetAddress,
  streetAddressError,
  streetAddressValid,
  setIsError,
  validateCity,
  cityError,
  cityValid,
  validatePostalCode,
  postalCodeError,
  postalCodeValid,
  validateApartment,
  apartmentError,
  apartmentValid,
  setNSCAFAPIResponse
}) => {
  // const dispatch = useDispatch()
  const NSCAF_API = process.env.REACT_APP_NSCAF_API;
  const NSCAF_API_KEY = process.env.REACT_APP_NSCAF_API_KEY;
  const [isFocussed, SetIsFocussed] = useState(false);
  const divRef = useRef(null);
  const streetAddress = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty).streetAddress
  );
  const [civicAddress, setCivicAddress] = useState();

  //turns dropdown on and off
  const [display, setDisplay] = useState(false);

  const [streetname, setStreetname] = useState([]);

  const [streetNameFull, setStreetNameFull] = useState([]);

  const [cityName, setCityName] = useState([]);
  // const [postalCodeReadOnly, setPostalCodeReadOnly] = useState(true);
  const [cityReadOnly, setCityReadOnly] = useState(false);
  const [civNumId, setCivNumId] = useState([]);
  const [civicNum, setCivicNum] = useState(null);
  // const [NSCAFAPIResponse, setNSCAFAPIResponse] = useState(null);

  const [focusedItem, setFocusedItem] = useState(0);
  const containerRef = useRef(null);

  useEffect(() => {
    // Scroll to the selected item when it changes
    if (focusedItem !== null && containerRef.current) {
      const focusedItemElement = containerRef.current.children[focusedItem];
      if (focusedItemElement) {
        focusedItemElement.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        });
      }
    }
  }, [focusedItem]);

  const handleKeyDown = (event) => {
    if (event.key === 'ArrowUp') {
      setFocusedItem((prev) => (prev === null ? 0 : (prev - 1 + streetNameFull.length) % streetNameFull.length));
    } else if (event.key === 'ArrowDown') {
      setFocusedItem((prev) => (prev + 1) % streetNameFull.length);
    } else if (event.key === 'Enter' && focusedItem !== null && focusedItem !== 0) {
      // Handle item selection
      setAddressInput(focusedItem);
      setCityInput(focusedItem);
      setPostalInput(focusedItem);
    }
  };

  const handleStreetAddress = (e) => {
    let name = e?.currentTarget?.value;
    let addressVal = name;
    if (name !== "") {
      setDisplay(true);
    }
    setFocusedItem(0);
    changeObjectPropertyAction("streetAddress", name);
    // changeObjectPropertyAction("city", '');
    // changeObjectPropertyAction("postalCode", '');
    changeObjectPropertyAction("civicId", null);
    for (let i = 0; i < streetShortForms?.length; i++) {
      addressVal = addressVal?.toLowerCase()?.replace(streetShortForms[i]?.name, streetShortForms[i]?.value);
    }
    if (name.length >= 0) {
      fetch(
        NSCAF_API +
        `?max_recs=100&reqd_wkid=2961&tkey=${NSCAF_API_KEY}&inclAlias=true&search_str=` +
        addressVal
      )
        .then(response => {
          if (!response?.ok) {
            console.log('data response');
            changeObjectPropertyAction("civicId", 0);
            // setPostalCodeReadOnly(false);
            setNSCAFAPIResponse(false);
            setCityReadOnly(false);
            validateStreetAddress(name);
            // validateCity(null, false);
            validatePostalCode(null, false);
            return Promise?.reject(response);
          }
          return response?.json();
        })
        .then((data) => {
          console.log('data returned');
          setNSCAFAPIResponse(true);
          validateStreetAddress(name, null);
          // validateCity(null, null);
          validatePostalCode(null, null);
          setAllStreetValues(name, data);
        })
        .catch(error => {
          changeObjectPropertyAction("civicId", 0);
          validateStreetAddress(name);
          setNSCAFAPIResponse(false);
          // setPostalCodeReadOnly(false);
          setCityReadOnly(false);
          validateCity(null, true);
          validatePostalCode(null, true);
          if (typeof error.json === "function") {
            error.json().then(jsonError => {
              console.log("Json error from API");
            }).catch(genericError => {
              console.log("Generic error from API");
            });
          } else {
            console.log("Fetch error: ", error.message);
            console.log(error);
          }
        });
    } else {
      validateStreetAddress(name);
      // validateCity(null, false);
      validatePostalCode(null, false);
    }
  };


  //   useEffect(() => {
  //     const handleClickOutside = (event) => {
  //       if (focusedItem.current && !focusedItem.current.contains(event.target)) {
  //         setDisplay(false);
  //       }
  //     };

  //     document.addEventListener("mousedown", handleClickOutside);

  //     return () => {
  //       document.removeEventListener("mousedown", handleClickOutside);
  //     };
  //   }, []);

  function setAllStreetValues(name, dataArr) {
    const tempSt = [];
    const tempStFull = [];
    const tempCity = [];
    const tempCivicNumberId = [];
    for (let i = 0; i < dataArr.results?.length; i++) {
      if (dataArr.results?.[i]?.civic_address_as_string !== undefined) {
        const streetAddress = dataArr.results?.[i]?.civic_address_as_string?.split(',');
        const street = streetAddress[0];
        const city = streetAddress[1];
        tempSt.push(
          street
          // dataArr.civicResults?.[i]?.civicnumber +
          // " " +
          // dataArr.civicResults?.[i]?.streetname +
          // " " +
          // dataArr.civicResults?.[i]?.streetsuffix
        );
        tempStFull.push(
          street + ', ' + city
          // dataArr.civicResults?.[i]?.civicnumber +
          // " " +
          // dataArr.civicResults?.[i]?.streetname +
          // " " +
          // dataArr.civicResults?.[i]?.streetsuffix +
          // ", " +
          // dataArr.civicResults?.[i]?.community
        );
        tempCity.push(city);
        tempCivicNumberId.push(dataArr.results?.[i]?.civicnumberid);
        // tempCity.push(dataArr.civicResults?.[i]?.community);
        // tempCivicNumberId.push(dataArr.civicResults?.[i]?.civicnumberid);
      }
    }
    setStreetname(tempSt);
    setStreetNameFull(tempStFull);
    setCityName(tempCity);
    setCivNumId(tempCivicNumberId);
  }

  const onBlurStreetAddress = (e) => {
    try {
      SetIsFocussed(false);
      let name = e.currentTarget.value.trim();
      changeObjectPropertyAction("streetAddress", name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onClickStreetAddress = (e) => {
    try {
      setDisplay(!display);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  //triggered by onClick of address dropdown div
  const setAddressInput = (index) => {
    let name = streetname[index];
    setCivicNum(civNumId[index]);
    changeObjectPropertyAction("streetAddress", name);
    validateStreetAddress(name);
    setDisplay(false);
  };

  let city = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty).city
  );

  const setCityInput = (index) => {
    try {
      let name = cityName[index];
      changeObjectPropertyAction("city", name);
      validateCity(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };
  const [isFocussed2, SetIsFocussed2] = useState(false);

  const handleCity = (e) => {
    try {
      let name = e.currentTarget.value;
      changeObjectPropertyAction("city", name);
      validateCity(name, null);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onBlurCity = (e) => {
    try {
      SetIsFocussed2(false);
      let name = e.currentTarget.value.trim();
      changeObjectPropertyAction("city", name);
      // validateCity(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  useEffect(() => {
    // setCivicAddress(streetAddress + `${city ? ', ' + city : ''}`);
    setCivicAddress(streetAddress);
  }, [streetAddress, city]);

  //Postal Code

  let postalCode = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty).postalCode
  );

  const getPostalCode = async (civicNum) => {
    try {
      if (civicNum) {
        const promise = await fetch(
          "https://nsgi.novascotia.ca/nsaddress/civic/nscaf.svc/rest/json/CivicAddress/" +
          civicNum
        );
        const json = await promise.json();
        const json2 = await json?.civicResults?.addresses[0]?.postalcode;
        return json2;
      }
      return null

    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const setPostalInput = async (index) => {
    try {
      let civicNumberId = civNumId[index];
      let name = await getPostalCode(civicNumberId);
      // if (name) {
      //   setPostalCodeReadOnly(true);
      // } else {
      //   setPostalCodeReadOnly(false);
      // }
      changeObjectPropertyAction("civicId", civicNumberId);
      changeObjectPropertyAction("postalCode", name);
      if (name && name !== '' && name !== null) {
        validatePostalCode(name?.replace(" ", "")?.toUpperCase());
      }
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const handlePostalCode = (e) => {
    try {
      let name = e.currentTarget.value;
      changeObjectPropertyAction("postalCode", name);
      if (name && name !== '' && name !== null) {
        const code = name?.replace(" ", "").toUpperCase();
        validatePostalCode(code, null);
      }
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onBlurPostalCode = (e) => {
    try {
      SetIsFocussed(false);
      let name = e.currentTarget.value.replace(" ", "").toUpperCase();
      changeObjectPropertyAction("postalCode", name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  //Apartment

  const apartment = useSelector(
    (state) => getNestedProperty(state.app, reduxAppProperty).apartment
  );

  const handleApartment = (e) => {
    try {
      let name = e.currentTarget.value;
      changeObjectPropertyAction("apartment", name);
      validateApartment(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const onBlurApartment = (e) => {
    try {
      SetIsFocussed(false);
      let name = e.currentTarget.value.trim();
      changeObjectPropertyAction("apartment", name);
      validateApartment(name);
    } catch (err) {
      console.log(err);
      setIsError(true);
    }
  };

  const handleClickOutside = (event) => {
    // Check if the clicked target is outside the div
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setDisplay(false)
      // Your code to handle the click outside event
    }
  };

  useEffect(() => {
    // Add event listener when component mounts
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener when component unmounts
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  // --------------------------------------------------------------------------------------------------------------------------------------

  const warningContent = (<div>

    {t("home_information.warning_text2_2")}
    <a href="tel:9024245200">902-424-5200</a>{" "}
    {t("home_information.warning_text2_3")}{" "}
    <a href="tel:18006704357">1-800-670-4357</a>
    {t("home_information.warning_text2_4")}
    <a href="mailto:onlinehelp@novascotia.ca">onlinehelp@novascotia.ca</a>
    . </div>)

  return (
    <div style={{ position: "relative" }}>
      <StatusInputWrapper
        isValid={streetAddressValid}
        errorMsg={streetAddressError}
        t={t}
        label={label ?? t("home_information.street_address")}
        helperText={t("home_information.street_address_helper")}
        isFocussed={isFocussed}
        id="StreetAddress"
        name="StreetAddress"
        type="text"
        customClasses={"fw-20"}
        aria-describedby="street-address"
        onClick={onClickStreetAddress}
        onChange={handleStreetAddress}
        onBlur={onBlurStreetAddress}
        onFocus={() => SetIsFocussed(true)}
        value={civicAddress}
        autoComplete="off"
        maxLength="57"
        onKeyDown={handleKeyDown}
        tabIndex={0}
      />
      {display && (
        <div
          ref={containerRef}
          className="autoContainer" style={{
            overflowY: 'scroll',
            maxHeight: '300px', width: 'auto'
          }}>
          {streetNameFull.map((v, i) => {
            return (
              <div
                aria-selected={i === focusedItem}
                style={{ cursor: "pointer", width: 'auto' }}
                className={i === focusedItem ? styles['focused'] : 'option'}
                onClick={() => {
                  setAddressInput(i);
                  setCityInput(i);
                  setPostalInput(i);
                  // validateStreetAddress(streetname[i]);
                }}
                key={i}
              >
                <span className="col-xs-10 col-md-8">{v}</span>
              </div>
            );
          })}
        </div>
      )}

      {/* <div className="row"> */}
      {/* </div> */}

      <StatusInputWrapper
        isValid={apartmentValid}
        errorMsg={apartmentError}
        t={t}
        label={t("mailing_address.apartment")}
        helperText={t("home_information.apartment_unit_helper")}
        customClasses={"fw-10"}
        id="Apartment"
        name="Apartment"
        type="text"
        isFocussed={isFocussed}
        aria-describedby="apartment"
        onChange={handleApartment}
        onBlur={onBlurApartment}
        onFocus={() => SetIsFocussed(true)}
        value={apartment}
        autoComplete="off"
        maxLength="5"
      />

      <StatusInputWrapper
        isValid={cityValid}
        errorMsg={cityError}
        t={t}
        label={t("mailing_address.city")}
        customClasses={"fw-10"}
        id="City"
        name="City"
        type="text"
        readOnly={cityReadOnly}
        isFocussed={isFocussed2}
        aria-describedby="city"
        onChange={handleCity}
        onBlur={onBlurCity}
        onFocus={() => SetIsFocussed2(true)}
        value={city}
        autoComplete="off"
        maxLength="50"
      />

      <StatusInputWrapper
        // readOnly={postalCodeReadOnly}
        isValid={postalCodeValid}
        errorMsg={postalCodeError}
        t={t}
        label={t("mailing_address.postal_code")}
        id="PostalCode"
        name="PostalCode"
        type="text"
        isFocussed={isFocussed}
        aria-describedby="postal-code"
        customClasses={"fw-6"}
        onChange={handlePostalCode}
        onBlur={onBlurPostalCode}
        onFocus={() => SetIsFocussed(true)}
        value={postalCode}
        autoComplete="off"
        maxLength="6"
      />

      {/* Province - hard coded */}
      <div className="ns-label-wrapper col-sm-8 col-xs-12" style={{
        marginBottom: ".5em", background: "#EEEEEE",
        border: "1px solid #D9D9D9", height: "100px"
      }} >
        <label className="ns-label">
          {t("home_information.street_address")}:
        </label>

        <div style={{ marginBottom: ".5em" }} className="ns-hint">
          {apartment ? apartment + ' -' : ''} {streetAddress}  {city ? ',  ' + city + ', NS' : ''}
          {postalCode ? ',  ' + postalCode : ''}
        </div>
      </div>

      <div
        class="col-xs-12 help-text blockquote-alert"
        style={{
          display: "flex", padding: "0", alignItems: "center"
        }}
      >
        <i
          class="fa fa-exclamation-circle"
          aria-hidden="true"
          style={{ marginBottom: "0" }}
        ></i>
        <p style={{ margin: "0 1.5em" }}>
          <strong>
            {t("home_information.warning_text2_1")}
          </strong>
          <br />
          {t("home_information.warning_text2_2")}
          <a href="tel:9024245200">902-424-5200</a>{" "}
          {t("home_information.warning_text2_3")}{" "}
          <a href="tel:18006704357">1-800-670-4357</a>
          {t("home_information.warning_text2_4")}
          <a href="mailto:onlinehelp@novascotia.ca">onlinehelp@novascotia.ca</a>
          .
        </p>
      </div>



      {/* <StatusInputWrapper
        isValid={streetAddressValid}
        errorMsg={streetAddressError}
        t={t}
        label={label ?? t("home_information.street_address")}
        helperText={t("home_information.street_address_helper")}
        isFocussed={isFocussed}
        id="StreetAddress"
        name="StreetAddress"
        type="text"
        customClasses={"fw-20"}
        aria-describedby="street-address"
        onClick={onClickStreetAddress}
        onChange={handleStreetAddress}
        onBlur={onBlurStreetAddress}
        onFocus={() => SetIsFocussed(true)}
        value={streetAddress}
        autoComplete="off"
        maxLength="57"
      /> */}

      {/* <div className="ns-label-wrapper col-xs-8" style={{
        marginBottom: ".5em", background: "#EEEEEE",
        border: "1px solid #D9D9D9", height: "100px"
      }} >
        <label className="ns-label">
          {t("home_information.street_address")}:
        </label>

        <div style={{ marginBottom: ".5em" }} className="ns-hint">
          {streetAddress}
        </div>
      </div> */}
    </div>
  );
};

export default withTranslation("common")(AddressAutofill);
